import { ApiProperty } from "@nestjs/swagger";

export class EmployeeTeamRequest{

    @ApiProperty()
    id:number;

    @ApiProperty()
    isActive:boolean;

    @ApiProperty()
    updatedUser:string;

    @ApiProperty()
    versionFlag:number;
}